import { HttpFilter } from "sol-request-angular/dist/comunicacao";
import { Equal } from "sol-request-angular/dist/comunicacao/filter/Equal";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";

export class PessoaJuridicaSearch {

    nmPessoa: string;
    tpConcessao: number;
    limit: number;

    constructor(data: { nmPessoa?: string, tpConcessao?:number, limit?: number }) {
        this.nmPessoa = data && data.nmPessoa;
        this.tpConcessao = data && data.tpConcessao
        this.limit = data && data.limit;
    }

    getFilters(): IFilter {
        let filtros: IFilter = new HttpFilter([
            new Equal('limit', 50)
        ]);

        if (this.nmPessoa) {
            filtros.addFilter(new Equal('nmPessoa', this.nmPessoa));
        }
        
        if (this.tpConcessao !== undefined) {
            filtros.addFilter(new Equal('tpConcessao', this.tpConcessao));
        }
        
        return filtros;
    }

}